<template>
  <div id="page-projects">
    <div class="container">
        <div class="gr-12 gr-10@lg push-1@lg">
            <div class="wysiwyg">
                <h3>Our projects</h3>
                <p>Cras mattis consectetur purus sit amet fermentum. Curabitur blandit tempus porttitor. Maecenas sed diam eget risus varius blandit sit amet non magna.</p>
            </div>
        </div>

        <div class="gr-12">
            <div class="filterButtons">
                <div class="filterButtons__wrapper">
                    <input type="radio" v-model="odabranaKategorija" value="all" id="filter_all" name="filterCategory" selected/>
                    <label class="filterButtons__label" for="filter_all">Show All</label>
                </div>

                <div v-for="kat in kategorije" :key="kat.id" class="filterButtons__wrapper">
                    <input type="radio" v-model="odabranaKategorija" :value="kat.id" :id="kat.id" name="filterCategory" />
                    <label class="filterButtons__label" :for="kat.id">{{ kat.name }}</label>
                </div>
            </div>
        </div>

        <div class="gr-12">
            <ul class="products__list">
                <li v-for="(project, index) in filteredPosts" :key="project.id" class="products__item" :class="{'products__item--reversed': index % 2 !== 0}">
                    <div class="card card--03">
                        <a href="#" class="card__link">
                            <figure class="card__figure">
                                <img :src="project.picture" alt="" class="rspimg">
                            </figure>
                            <div class="card__data">
                                <header>
                                    <h3 class="card__title">{{ project.title }}</h3>
                                    <p class="card__description">{{ project.address }}</p>
                                </header>

                                <div class="card__excerpt">{{ project.excerpt }}</div>
                                <svgicon name="arrow-right" width="12" color="#000000"></svgicon>
                            </div>
                        </a>
                    </div>
                </li>
            </ul>
        </div>
    </div>

    <Prefooter />
    <Footer />

  </div>
</template>


<script>
// components
import Prefooter from '@/components/Prefooter.vue';
import Footer from '@/components/Footer.vue'

//import icons
import '@/compiled-icons/arrow-right';

export default {
    name: 'projects',
    components: {
        Prefooter,
        Footer
    },

    data () {
        return {
            projectsList: [],
            kategorije: [
                {id: 1, name: "Interior Design"},
                {id: 2, name: "3D Visualization"},
                {id: 3, name: "Other Design"},
            ],
            odabranaKategorija: "all",
        }
    },
    mounted() {
        var url = 'https://next.json-generator.com/api/json/get/E1_rv3NNv';

        fetch(url).then((response)=>{
            return response.json()
        }).then((data)=>{
            this.projectsList = data;
        });
    },
    computed: {
        filteredPosts: function() {
            var vm = this;
            var category = vm.odabranaKategorija;
            
            if(category === "all") {
                return vm.projectsList;
            } else {
                return vm.projectsList.filter(function(objava) {
                    return objava.category.includes(category);
                });
            }
        }


        // Display only 5 posts
        // limitedProductList() {
        //     return this.projectsList.slice(0, 5);
        // }
    }
};
</script>


<style scoped lang="scss">
    @import "@/scss/modules/_products.scss";

    .wysiwyg {
        margin: 0 0 40px 0;
        text-align: center;

        @include min-screen($lg) {
            margin: 0 0 60px 0;
        }
    }

</style>